import { PanelBody, ToggleControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

const BlockVisibilityOptions = props => {
  const {
    setAttributes
  } = props;

  const {
    hideOnMobile,
    hideOnDesktop
  } = props.blockAttributes;

  return (
    <PanelBody
      className="visibility"
      title={ __("Visibility") }
    >
      <ToggleControl
        label={ __("Hide on Mobile") }
        checked={ hideOnMobile }
        onChange={ hideOnMobile => setAttributes({ hideOnMobile }) }
      />

      <ToggleControl
        label={ __("Hide on Desktop") }
        checked={ hideOnDesktop }
        onChange={ hideOnDesktop => setAttributes({ hideOnDesktop }) }
      />
    </PanelBody>
  )
}

export default BlockVisibilityOptions;
